// Traçabilité des moteurs CVC copiés de VLT Devis : affichée à l'écran et imprimée dans la note de calcul.
// Toute nouvelle copie (mise à jour depuis l'origine) change ces empreintes ET la version ci-dessous.

export const VERSION_MOTEURS_CVC = 'trame-cvc-2026-10-07.1';

export const ORIGINE_MOTEURS_CVC = Object.freeze({
  depot: 'VLT Devis (vlt-devis-saas), public/outils/metiers/cvc/',
  commit: '53f27dce35157919e1bdb92bf9dcd6c1e135e83c',
  date: '18/09/2026',
  copie: '07/10/2026',
  fichiers: Object.freeze([
    { fichier: 'psychro.mjs', sha256: '1547C89CB7671D62EFC0A55E306345B029693439C3ED45151ADCB834EE9309F0', reprise: 'tel quel' },
    { fichier: 'zones-climatiques.mjs', sha256: '7A397B6273A7DC72DD62C1A4F5EAD537630CDD9CB5DF9B07F73230DA699765E3', reprise: 'tel quel' },
    { fichier: 'zones.mjs', sha256: '316D41C34A3FCC39B7D54CDD65E236FCCB952F5B9AB3737B1BD19CC063D51275', reprise: 'tel quel' },
    { fichier: 'froid.mjs', sha256: '88F431186EB2F64E54EFE1AE9669DD344EC4BC4B173DDAEA112C1146138617DD', reprise: 'adapté (A1 à A3)' },
    { fichier: 'chaud.mjs', sha256: '36E582E7284D403F07BE6929461715C4F628BA27FB034A5E28A4C77A29F7F370', reprise: 'adapté (A4)' },
  ]),
});

/** Adaptations TRAME, toutes À VALIDER par le dirigeant (recette du 06/10/2026, § 9.4). */
export const ADAPTATIONS_CVC = Object.freeze([
  { code: 'A1', texte: 'Types de locaux d’ERP (salle de culte ou polyvalente, classe, salle de réunion) ; apports par occupant du public assis réglables (70 W sensibles + 45 W latents par défaut), source affichée.' },
  { code: 'A2', texte: 'Option « air neuf prétraité par une CTA » : la ventilation du local arrive à l’état de soufflage saisi ; la charge de l’air neuf jusqu’à cet état est sortie à part, à reprendre par la CTA.' },
  { code: 'A3', texte: 'Au-delà de 4 m de hauteur : alerte F04 maintenue, aucune stratification calculée.' },
  { code: 'A4', texte: 'Puissance réelle des émetteurs à eau en basse température : P = P_nominale × (ΔT / ΔT_nominal)^n, exposant n réglable (1,3 par défaut, à valider sur la fiche du fabricant).' },
  { code: 'B1', texte: 'Bornes de saisie relevées pour l’ERP : 2 000 personnes par local, 60 locaux, 12 vitrages par local.' },
  { code: 'B2', texte: 'Local d’ERP occupé sans débit d’air neuf saisi : alerte V01 (aucun débit déduit de l’effectif).' },
  { code: 'B3', texte: 'Émetteurs à eau existants comparés aux déperditions du local au régime d’eau saisi : alerte E02 s’ils sont insuffisants.' },
]);
